var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 13.2755L26.25 20.2755L41.9545 4.571C41.6203 1.99675 39.4153 0 36.75 0H5.25C2.3555 0 0 2.3555 0 5.25V32.5255L19.25 13.2755ZM9.625 8.75C11.074 8.75 12.25 9.926 12.25 11.375C12.25 12.824 11.074 14 9.625 14C8.176 14 7 12.824 7 11.375C7 9.926 8.176 8.75 9.625 8.75ZM42 9.4745V35H30.0072L23.2767 40.565C22.6432 41.1285 21.833 41.4138 21.0157 41.4138C20.1827 41.4138 19.3427 41.118 18.6742 40.523L12.1152 35H2.4745L19.25 18.2245L26.25 25.2245L42 9.4745Z",
    fill: "#64BE6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosts);
export default __webpack_public_path__ + "static/media/Posts.c486c5b93bb0dca981bd52d6716b8157.svg";
export { ForwardRef as ReactComponent };